import styled, { css } from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { token } from 'odyssey';

export const ItemWrapper = styled.article`
  display: flex;
  flex-direction: column;
  padding-left: 9px;
  padding-right: 9px;
  width: 100%;
  max-width: 100%;
`;

export const ItemDescription = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  max-width: 100%;
`;

export const ItemRow = styled.div`
  min-height: 38px;
  padding: 0 ${token('space-1')};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ItemCol = styled.div`
  flex-direction: column;
`;

export const ItemName = styled.div`
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin-bottom: 8px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  cursor: pointer;
  overflow-wrap: break-word;
  word-break: break-word;
  ${media.md`
    font-size: 18px;
  `};
`;

export const ItemAttributes = styled.div`
  padding: 0 ${token('space-1')};
  margin-bottom: ${({ theme }) => theme.spaces.space4};
`;

export const ItemPrice = styled.div`
  & > span {
    font-size: 14px;
    display: flex;
    color: ${({ theme }) => theme.defaultColors.fontSecondary};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
  }
`;
export const MetadataRow = styled.p`
  font-size: 15px;
  line-height: 23px;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  margin-top: 0;
  min-height: 20px;
`;

export const PriceWrapper = styled.div<{ isFixedPrice?: boolean }>`
  display: inline;
  font-size: 16px;
  ${(p) =>
    !p.isFixedPrice &&
    css`
      margin: 0 4px;
    `}
  letter-spacing: 0.06em;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
`;

export const ItemImageWrapper = styled.div<{ isTransparent?: boolean }>`
  display: block;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  opacity: ${({ isTransparent }) => (isTransparent ? 0.4 : 1)};

  & > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
`;

export const NoAvailabilityStyled = styled.span`
  display: flex;
  border-radius: 999px;
  background: ${({ theme }) => theme.defaultColors.lighterGrey};
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  padding: 7px 12px;
  font-size: 12px;
`;

export const PaymentTermsRow = styled.div`
  display: flex;
  padding: 0 ${token('space-1')} ${token('space-1')};
  margin-bottom: ${({ theme }) => theme.spaces.space4};
`;

export const UnAvailableWrapper = styled.div`
  padding: 0 ${token('space-1')} 50px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const BriefDescription = styled.div`
  padding: 0 ${token('space-1')};
  font-size: 15px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  margin-bottom: 6px;
`;

export const CallToActionWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 6px;
  padding: ${token('space-2')} ${token('space-4')};
  border-radius: ${token('border-radius-xl')};
  background: ${token('button-primary-bg')};
  color: ${token('button-primary-fg')};
  font-size: ${token('font-size-sm')};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  line-height: 1;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.25s ease;

  &:hover {
    background: ${token('button-primary-hover-bg')};
  }
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  max-width: 100%;
  margin: ${token('space-2')} ${token('space-1')} 0;
`;
